import Box from '@mui/material/Box'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'

const UnwatchedBadge = ({ reclip, size = 10, sx }) => {
  if (!reclip?.show_new_badge) return null

  return (
    <Box
      title="unwatched"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...sx,
      }}
    >
      <FiberManualRecordIcon sx={{ fontSize: size, color: '#58a6ff' }} />
    </Box>
  )
}

export default UnwatchedBadge
